module.exports = __webpack_public_path__ + "static/media/20ECE2.f7fcd986.jpg";